import { Box } from "@chakra-ui/react";

export default function PaymentAlerts(props: { error: string | null; success: string | null }) {
  const { error, success } = props;

  return (
    <>
      {error ? (
        <Box mb="12px" p="12px" borderRadius="12px" bg="#FDECEC" color="#B42318" fontSize="13px">
          {error}
        </Box>
      ) : null}

      {success ? (
        <Box mb="12px" p="12px" borderRadius="12px" bg="#ECFDF3" color="#027A48" fontSize="13px">
          {success}
        </Box>
      ) : null}
    </>
  );
}
